import { render, staticRenderFns } from "./UserVoucherList.vue?vue&type=template&id=4dae537c&scoped=true&lang=pug&"
import script from "./UserVoucherList.vue?vue&type=script&lang=ts&"
export * from "./UserVoucherList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dae537c",
  null
  
)

export default component.exports